(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'explorePage', {
            templateUrl:    'app/views/explore.html',
            controller:     ExplorePageController,
            controllerAs:   'vm'
        });


    /**
     * Homepage of the app.
     *
     * @param {ng.IScope} $scope
     * @param {LoadingManager} LoadingManager
     */
    function ExplorePageController(
        $scope,
        LoadingManager,
        CONFIG
    ){
        // Helping members

        /** @type {ng.IController} */
        var vm = this;


        $scope.CONFIG = CONFIG;


        /** @constructor */
        vm.$onInit = function() {
            LoadingManager.loadingPending();
            LoadingManager.loadingDone();
        }
    }


    ExplorePageController.$inject = [ '$scope', 'LoadingManager', 'CONFIG' ];
}());
